<template>
    <user-add-form></user-add-form>
</template>


<script>

    import UserAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            UserAddForm,
        },

    }
</script>

